/* SAVR Support Hub — search, filter and nav highlighting. Registered as a custom element so it re-initialises whenever the section is (re)rendered, including inside the theme editor. */
(function () {
  if (customElements.get('savr-support-hub')) return;

  const CSS = [
    '.sv-results{display:none;align-items:center;gap:1rem;flex-wrap:wrap;margin:-1.5rem 0 1.5rem;padding:.9rem 1rem;background:#f7f5f1;border-left:4px solid #F26B21;font-size:.98rem}',
    '.sv-results.show{display:flex}',
    '.sv-results b{font-weight:600}',
    '.sv-results button{font:inherit;font-size:.9rem;margin-left:auto;background:#fff;border:1px solid #0B0B0B;border-radius:999px;padding:.35rem .9rem;cursor:pointer;color:#0B0B0B}',
    '.sv-results button:hover,.sv-results button:focus-visible{background:#0B0B0B;color:#fff;outline:none}',
    'savr-support-hub.searching .sv-tiles,savr-support-hub.searching .sv-facts,savr-support-hub.searching .sv-nav{display:none}',
    'savr-support-hub.searching .sv-layout{grid-template-columns:1fr;gap:0}',
    'savr-support-hub.searching .sv-group{margin-bottom:2rem}'
  ].join('\n');

  function ensureStyle() {
    if (document.getElementById('sv-hub-style')) return;
    const s = document.createElement('style');
    s.id = 'sv-hub-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  class SavrSupportHub extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
      } else {
        this.setup();
      }
    }

    setup() {
      ensureStyle();
      const root = this;
      const input = root.querySelector('#sv-q');
      const empty = root.querySelector('#sv-empty');
      if (!input || !empty) return;

      const groups = Array.from(root.querySelectorAll('.sv-group'));
      const qs = Array.from(root.querySelectorAll('.sv-q'));
      const navLinks = Array.from(root.querySelectorAll('.sv-nav a'));

      // Results bar, inserted just under the "Common searches" line
      let results = root.querySelector('.sv-results');
      if (!results) {
        results = document.createElement('div');
        results.className = 'sv-results';
        results.setAttribute('role', 'status');
        results.setAttribute('aria-live', 'polite');
        results.innerHTML = '<span class="sv-results-text"></span><button type="button">Clear search</button>';
        const hint = root.querySelector('.sv-hint');
        (hint || input.parentElement).insertAdjacentElement('afterend', results);
      }
      const resultsText = results.querySelector('.sv-results-text');
      const clearBtn = results.querySelector('button');

      qs.forEach((q) => {
        q._text = q.textContent.toLowerCase();
        q._sum = q.querySelector('summary');
        q._sumHtml = q._sum ? q._sum.innerHTML : '';
      });

      const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      const filter = () => {
        const raw = input.value.trim();
        const terms = raw.toLowerCase().split(/\s+/).filter(Boolean);
        let count = 0;

        qs.forEach((q) => {
          const hit = terms.every((t) => q._text.indexOf(t) > -1);
          q.hidden = !hit;
          if (terms.length && hit) {
            count++;
            q.open = true;
            let html = q._sumHtml;
            terms.forEach((t) => {
              html = html.replace(new RegExp('(' + esc(t) + ')', 'ig'), '<mark>$1</mark>');
            });
            if (q._sum) q._sum.innerHTML = html;
          } else {
            if (q._sum) q._sum.innerHTML = q._sumHtml;
            if (!terms.length) q.open = false;
          }
        });

        groups.forEach((g) => {
          if (!g.querySelector('.sv-q')) {
            g.hidden = terms.length > 0;
            return;
          }
          g.hidden = !g.querySelectorAll('.sv-q:not([hidden])').length;
        });

        const searching = terms.length > 0;
        root.classList.toggle('searching', searching);
        empty.classList.toggle('show', searching && count === 0);
        if (searching) {
          resultsText.innerHTML = count
            ? '<b>' + count + (count === 1 ? ' answer' : ' answers') + '</b> for \u201c' + raw.replace(/[<>&]/g, '') + '\u201d'
            : 'No answers for \u201c' + raw.replace(/[<>&]/g, '') + '\u201d';
          results.classList.add('show');
        } else {
          results.classList.remove('show');
        }
      };

      const clear = () => {
        input.value = '';
        filter();
        input.focus();
      };

      let timer;
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(filter, 120);
      });
      input.addEventListener('search', filter);
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          filter();
        } else if (e.key === 'Escape') {
          clear();
        }
      });
      clearBtn.addEventListener('click', clear);

      root.querySelectorAll('.sv-hint button').forEach((b) => {
        b.addEventListener('click', () => {
          input.value = b.getAttribute('data-fill') || '';
          filter();
          input.focus();
        });
      });

      const m = location.search.match(/[?&]q=([^&]+)/);
      if (m) {
        input.value = decodeURIComponent(m[1].replace(/\+/g, ' '));
        filter();
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                navLinks.forEach((a) => {
                  a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id);
                });
              }
            });
          },
          { rootMargin: '-20% 0px -70% 0px' }
        );
        groups.forEach((g) => io.observe(g));
      }
    }
  }

  customElements.define('savr-support-hub', SavrSupportHub);
})();
